import { ActionContext, MutationTree, ActionTree, GetterTree } from 'vuex'
import webApi from '../webApi'
import { Service_Leg } from '../webApi/DataModels'
import { map, filter } from 'lodash'

class Service_LegState {
  public service_Legs: Service_Leg[] = []
  public service_LegOptions: any[] = []
}

const mutations = <MutationTree<Service_LegState>>{
  setService_Legs (state: Service_LegState, service_Legs: Service_Leg[]) {
    state.service_Legs = service_Legs
    state.service_LegOptions = service_Legs.map((service_Leg: Service_Leg) => {
      return {
        value: service_Leg.Service_Leg_ID,
        label: service_Leg.Service_Leg_Name,
        selected: false
      }
    })
    window.sessionStorage.setItem('Service_Leg_List', JSON.stringify(state.service_Legs))
  },
  reset (state:Service_LegState) {
    state.service_Legs = []
    state.service_LegOptions = []
  }
}

const actions = <ActionTree<Service_LegState, any>>{
  reset (store: ActionContext<Service_LegState, any>):void {
    store.commit('reset')
  },
  loadService_Legs (store: ActionContext<Service_LegState, any>):Promise<any> {
    if (window.sessionStorage.getItem('Service_Leg_List') != null) {
      // the list has already been stored in session
      store.commit('setService_Legs', JSON.parse(window.sessionStorage.getItem('Service_Leg_List')))
      return Promise.resolve('success')
    } else {
      // the list has not been stored in session yet, load from server
      return webApi.service_Leg.get_Service_Legs().then(
        (response) => {
          // Store the response
          store.commit('setService_Legs', response.data)
          return Promise.resolve('success')
        }).catch((response) => {
        window.bus.$emit('openErrorModal', 'error loading service_Legs: ' + response.ExceptionMessage)
        return Promise.reject(response)
      })
    }
  }
}

const getters = <GetterTree<Service_LegState, any>>{
  service_Legs: (state) => {
    return state.service_Legs
  },
  service_LegOptions: (state) => {
    return state.service_LegOptions
  },
  service_LegNames (state:Service_LegState):any {
    return (service_LegIDs:number[]) => {
      return map(filter(state.service_Legs, service_Leg => (service_LegIDs.indexOf(service_Leg.Service_Leg_ID) > -1)), 'Service_Leg_Name')
    }
  }
}
export default ({
  namespaced: true,
  state: new Service_LegState(),
  mutations,
  actions,
  getters
})
